import React from 'react';
import { AlertTriangle, HelpCircle, CheckCircle } from 'lucide-react';

const ConfirmModal = ({ 
  isOpen, 
  type = 'confirm', // 'confirm', 'alert', 'danger', 'success'
  title, 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = "Evet, Onaylıyorum", 
  cancelText = "İptal" 
}) => {
  if (!isOpen) return null;

  // İkon ve Renk Temasını Belirleme
  let Icon = HelpCircle;
  let colorClass = "bg-blue-100 text-blue-600 border-blue-200";
  let btnClass = "bg-blue-600 hover:bg-blue-700 shadow-blue-200";

  if (type === 'alert' || type === 'danger') {
    Icon = AlertTriangle;
    colorClass = "bg-rose-100 text-rose-600 border-rose-200";
    btnClass = type === 'alert' ? "bg-slate-900 hover:bg-slate-800" : "bg-rose-600 hover:bg-rose-700 shadow-rose-200";
  } else if (type === 'success') {
    Icon = CheckCircle;
    colorClass = "bg-emerald-100 text-emerald-600 border-emerald-200";
    btnClass = "bg-emerald-600 hover:bg-emerald-700 shadow-emerald-200";
  }

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[110] flex items-center justify-center p-4 animate-in fade-in duration-200">
      <div className="bg-white rounded-3xl p-6 md:p-8 w-full max-w-sm shadow-2xl animate-in zoom-in-95 duration-200">
        
        <div className="flex flex-col items-center text-center mb-6">
          <div className={`h-16 w-16 rounded-full flex items-center justify-center mb-4 shadow-inner border ${colorClass}`}>
            <Icon className="h-8 w-8"/>
          </div>
          <h3 className="text-xl font-black text-slate-800 tracking-tight">{title}</h3>
          <p className="text-sm font-medium text-slate-500 mt-2 whitespace-pre-wrap">{message}</p>
        </div>

        <div className="flex gap-3 w-full">
          {type !== 'alert' && type !== 'success' && (
            <button onClick={onCancel} className="flex-1 py-3.5 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-xl font-bold text-sm transition">
              {cancelText}
            </button>
          )}
          <button onClick={onConfirm} className={`flex-1 py-3.5 text-white rounded-xl font-bold text-sm transition shadow-lg ${btnClass}`}>
            {type === 'alert' || type === 'success' ? 'Anladım' : confirmText}
          </button>
        </div>

      </div>
    </div>
  );
};

export default ConfirmModal;